document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.getElementById('custom-sticky-bar');
  const swatchPalette = document.getElementById('sticky-swatch-palette');
  const toggleArrow = document.getElementById('swatch-toggle-arrow');
  const selectedColorName = document.getElementById('selected-color-name');
  const productForm = document.querySelector('form[action="/cart/add"]');
  const formId = productForm?.getAttribute('id');
  const allColorSwatches = Array.from(
    document.querySelectorAll('.variant-picker__option-values .color-swatch')
  ).filter((swatchEl) => {
    const radioId = swatchEl.closest('label')?.getAttribute('for');
    return radioId && document.getElementById(radioId)?.form === productForm;
  });
  const stickyButton = document.querySelector('#custom-sticky-bar .add-to-cart-button');
  const footer = document.querySelector('footer');
  const observerTarget = document.querySelector('.product__media');
  const rerenderTarget = productForm?.closest('product-rerender') || productForm;
  const stickySwatches = [];
  const boundProductForms = new WeakSet();

  if (!stickyBar || !swatchPalette || !selectedColorName || !productForm) return;

  if (formId && stickyButton) {
    stickyButton.setAttribute('form', formId);
  }

  swatchPalette.classList.add('hide');

  const getCurrentProductForm = () =>
    document.getElementById(formId);

  const getVariantRadios = () =>
    getCurrentProductForm()?.querySelectorAll('input[name="id"][type="radio"]') || [];

  const getDefaultCartBtn = () =>
    getCurrentProductForm()?.querySelector('button[type="submit"]');

  allColorSwatches.forEach((swatchEl, index) => {
    const colorName =
      swatchEl.querySelector('span.sr-only')?.innerText || `Color ${index + 1}`;
    const label = swatchEl.closest('label');
    const radioId = label?.getAttribute('for');
    const targetInput = radioId ? document.getElementById(radioId) : null;

    if (!targetInput) return;

    let colorStyle =
      swatchEl.style.getPropertyValue('--swatch-background') ||
      swatchEl.getAttribute('style') ||
      '';

    if (colorStyle && !colorStyle.includes('background')) {
      colorStyle = `background: ${colorStyle};`;
    }

    const clone = document.createElement('div');
    clone.className = 'swatch';
    clone.setAttribute('title', colorName);

    if (colorStyle) clone.setAttribute('style', colorStyle);
    if (targetInput.checked) clone.classList.add('selected');

    clone.addEventListener('click', () => {
      const targetInput = document.getElementById(radioId);
      if (!targetInput) return;

      getVariantRadios().forEach((r) => {
        r.checked = false;
      });

      targetInput.checked = true;
      targetInput.dispatchEvent(new Event('change', { bubbles: true }));

      const variant = window.productData?.variants?.find(
        (v) => String(v.id) === String(targetInput.value)
      );

      if (variant?.featured_media?.id) {
        const mediaElem = document.querySelector(
          `[data-media-id="${variant.featured_media.id}"]`
        );
        if (mediaElem) mediaElem.click();
      }

      syncStickySelection();

      requestAnimationFrame(toggleStickyBar);
      setTimeout(toggleStickyBar, 120);
      setTimeout(toggleStickyBar, 300);
    });

    stickySwatches.push({ clone, colorName, radioId });
    swatchPalette.appendChild(clone);
  });

  function syncStickySelection() {
    const selectedSwatch = stickySwatches.find(
      ({ radioId }) => document.getElementById(radioId)?.checked
    );
    if (!selectedSwatch) return;

    selectedColorName.textContent = selectedSwatch.colorName;

    stickySwatches.forEach(({ clone }) => {
      clone.classList.toggle('selected', clone === selectedSwatch.clone);
    });
  }

  function syncStickyButton() {
    const defaultCartBtn = getDefaultCartBtn();
    if (!stickyButton || !defaultCartBtn) return;

    const isDisabled =
      defaultCartBtn.disabled || defaultCartBtn.getAttribute('aria-disabled') === 'true';
    const buttonText = defaultCartBtn.textContent.trim();

    stickyButton.disabled = isDisabled;
    stickyButton.setAttribute('aria-disabled', String(isDisabled));

    if (buttonText) {
      stickyButton.textContent = buttonText;
    }
  }

  function syncStickyState() {
    syncStickySelection();
    syncStickyButton();
  }

  function bindProductForm(currentProductForm) {
    if (
      !currentProductForm ||
      currentProductForm.getAttribute('id') !== formId ||
      boundProductForms.has(currentProductForm)
    ) {
      return;
    }

    boundProductForms.add(currentProductForm);

    currentProductForm.addEventListener('change', () => {
      requestAnimationFrame(toggleStickyBar);
      setTimeout(toggleStickyBar, 120);
      setTimeout(toggleStickyBar, 300);
    });

    currentProductForm.addEventListener('variant:change', (event) => {
      if (
        event.target !== currentProductForm ||
        event.detail?.formId !== formId ||
        !event.detail?.variant
      ) {
        return;
      }

      requestAnimationFrame(() => {
        syncStickyState();
        toggleStickyBar();
      });
    });
  }

  document.querySelector('.variant-label')?.addEventListener('click', () => {
    const isHidden = swatchPalette.classList.toggle('hide');
    if (toggleArrow) {
      toggleArrow.textContent = isHidden ? '▼' : '▲';
    }
  });

  function isElementInView(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function toggleStickyBar() {
    const defaultCartBtn = getDefaultCartBtn();
    const footerTop = footer?.getBoundingClientRect().top ?? Infinity;
    const observerTop = observerTarget?.getBoundingClientRect().top ?? 0;

    const cartBtnVisible = isElementInView(defaultCartBtn);

    if (footerTop < window.innerHeight || cartBtnVisible) {
      stickyBar.classList.add('hide');
      swatchPalette.classList.add('hide');
      if (toggleArrow) toggleArrow.textContent = '▼';
      return;
    }

    if (window.scrollY < 200) {
      stickyBar.classList.add('hide');
      return;
    }

    if (observerTop <= 0) {
      stickyBar.classList.remove('hide');
      return;
    }

    stickyBar.classList.remove('hide');
  }

  window.addEventListener('scroll', toggleStickyBar, { passive: true });
  window.addEventListener('resize', toggleStickyBar);

  bindProductForm(productForm);

  const formObserver = new MutationObserver(() => {
    bindProductForm(getCurrentProductForm());
    syncStickyState();
    toggleStickyBar();
  });

  formObserver.observe(rerenderTarget, {
    childList: true,
    subtree: true,
    attributes: true
  });

  syncStickyState();
  toggleStickyBar();
});
